/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import { toMessages } from 'config/messages';

export default toMessages('PrimaryNav.CountdownSubscribeLink', {
  Link: '{days} {days, plural, one {Day} other {Days}} Left'
});
